module.exports = __webpack_public_path__ + "img/default.8a0ed028.png";